import React, { useEffect, useState } from "react";
import Layout from "../../common/layout";
import { useTranslation } from "react-i18next";
import ListTable from "../../../elements/list/list";
import { Container } from "../../common/layout/styels";
const Authorisations = (props) => {
  const { t } = useTranslation();
  const [attributes] = useState([
    {
      type: "text",
      placeholder: "organization",
      name: "organization",
      validation: "",
      default: "",
      label: "organization",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "checkbox",
      placeholder: "location",
      name: "location",
      validation: "",
      showItem: "",
      default: "",
      label: "location",
      required: true,
      view: true,
      tag: true,
      add: false,
      update: true,
    },
    
    
  ]);

  //to update the page title
  useEffect(() => {
    document.title = `${t("authorisations")} - Whistleblowing24`;
  }, [t]);

  return (
    <Container className="noshadow">
      <ListTable {...props} api={`company`} itemTitle={`organization`} shortName={`authorisations`} addPrivilege={false} delPrivilege={false} updatePrivilege={true} attributes={attributes}></ListTable>
    </Container>
  );
};
// exporting the page with parent container layout..
export default Layout(Authorisations);
